__turbopack_context__.v({
  "className": "playfair_display_de868a64-module__EbvEgq__className",
  "variable": "playfair_display_de868a64-module__EbvEgq__variable",
});
